import { render } from "./Langs.vue?vue&type=template&id=536d2c5e"
import script from "./Langs.vue?vue&type=script&lang=js"
export * from "./Langs.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Langs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "536d2c5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('536d2c5e', __exports__)) {
    api.reload('536d2c5e', __exports__)
  }
  
  module.hot.accept("./Langs.vue?vue&type=template&id=536d2c5e", () => {
    api.rerender('536d2c5e', render)
  })

}


export default __exports__